<template>
    <component
        :is="pageTypeBanner"
        :page-type="pageType"
        data-banner
    />
</template>

<script setup>
    import HomeBanner from './HomeBanner.vue'
    import PageBanner from './PageBanner.vue'

    const { pageType } = storeToRefs(useGlobalStore())

    const pageTypeBanner = computed(() => {
        if (pageType.value === 'home') {
            return markRaw(HomeBanner)
        } else {
            return markRaw(PageBanner)
        }
    })
</script>
